import { render, staticRenderFns } from "./ThumbnailImg.vue?vue&type=template&id=c2bd2e00&scoped=true&"
import script from "./ThumbnailImg.vue?vue&type=script&lang=js&"
export * from "./ThumbnailImg.vue?vue&type=script&lang=js&"
import style0 from "./ThumbnailImg.vue?vue&type=style&index=0&id=c2bd2e00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bd2e00",
  null
  
)

export default component.exports